import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

export type GoogleResponse = {
  results: [
    {
      geometry: {
        location: {
          lat: number
          lng: number
        }
      }
    },
  ]
}

export const geocode = async (
  address: string,
): Promise<{ lat: number; lng: number } | undefined> => {
  const APIKEY = readFromEnv(Env.GoogleMapsApiKey)
  const BASE_URL = readFromEnv(Env.GoogleMapsBaseUrl)

  const client = axios.create({
    baseURL: BASE_URL,
  })

  const res = await client.request<GoogleResponse>({
    method: 'GET',
    url: `${BASE_URL}/geocode/json`,
    params: {
      address,
      key: APIKEY,
      region: 'uk',
      bounds: '49.00,-13.00|60.00,3.00',
    },
  })

  return res.data.results[0]?.geometry.location
}
